import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { INVOICE } from 'config/documents';
import InvoiceDocumentPreferences from '../../v2/InvoiceDocumentPreferences';
import { LoaderCircle } from 'lucide-react';
import { useGetDocumentTypes } from 'utils/DocumentsAPIUtils';

const { value: INVOICE_SLUG } = INVOICE;

export const ShipmentInvoiceDocumentPreferences = ({ preferences }) => {
  const { t } = useTranslation();

  const getInvoiceDocumentPreferences = () => {
    const invoicePreferences = (preferences || []).map((pref) => {
      if (pref.slug === 'invoice') {
        return {
          ...pref,
          slug: INVOICE_SLUG,
        };
      }
      return pref;
    });

    if (!invoicePreferences.find((pref) => pref.slug === INVOICE_SLUG)) {
      const sequence = invoicePreferences.length + 1;
      return [...invoicePreferences, { slug: INVOICE_SLUG, sequence }].sort(
        (a, b) => a.sequence - b.sequence,
      );
    }
    return invoicePreferences.sort((a, b) => a.sequence - b.sequence);
  };

  const { data: invoiceDocumentData, isLoading } = useGetDocumentTypes({
    listType: 'invoice',
    showListType: true,
  });

  const invoiceDocumentPreferenceDocTypes = useMemo(
    () => invoiceDocumentData?.getAvailableDocumentTypes || [],
    [invoiceDocumentData],
  );

  const invoiceDocumentPreferenceDocTypesMap = useMemo(
    () =>
      invoiceDocumentPreferenceDocTypes.reduce(
        (map, pref) => ({
          ...map,
          [pref.type]: pref,
        }),
        {},
      ),
    [invoiceDocumentPreferenceDocTypes],
  );

  const renderInvoicePreferences = () => {
    return (
      <Popover id="invoice-preferences-popover">
        <InvoiceDocumentPreferences
          invoiceDocumentPreferences={getInvoiceDocumentPreferences()}
          invoiceDocumentPreferenceDocTypesMap={
            invoiceDocumentPreferenceDocTypesMap
          }
        />
      </Popover>
    );
  };

  if (isLoading) {
    return <LoaderCircle className="w-4 h-4 animate-spin ml-2" />;
  }

  return (
    <div className="flex flex-1 justify-end">
      <OverlayTrigger
        className="dropdown-filter-wrapper"
        rootClose
        trigger="hover"
        placement="top"
        overlay={renderInvoicePreferences()}
      >
        <p className="underline cursor-pointer text-blue">
          {t('INVOICE_DOCUMENT_PREFERENCES')}
        </p>
      </OverlayTrigger>
    </div>
  );
};
